define((require) => {
    "use strict";

    const Class = require("shared/util/Class");

    /**
     * Represents a scale on two axises, x and y.
     *
     * @class Scale
     */
    const Scale = Class.extend({

        /**
         * Constructor.
         *
         * @param  {Number} x Optional scale value, from 0-1, representing the scale
         * on the x axis. Defaults to 1.0.
         *
         * @param  {Number} y Optional scale value, from 0-1, representing the scale
         * on the y axis. Defaults to 1.0.
         */
        constructor(x, y) {
            this.x = x || 1.0;
            this.y = y || 1.0;
        },

        average() {
            return (this.x + this.y) / 2;
        },

        equals(scale) {
            if (scale === this) {
                return true;
            }

            if (!(scale instanceof Scale)) {
                return false;
            }

            return scale.x === this.x && scale.y === this.y;
        },

        toString() {
            return `Scale[x: ${this.x}; y: ${this.y}]`;
        }

    }, {

        from(x, y) {
            return new Scale(x, y);
        }

    });

    return Scale;
});



// WEBPACK FOOTER //
// ./src/shared/util/Scale.js